import configureStore from '../app/store/configureStore';

export const store = configureStore();
